<template>
    <div>
        <a-card size="small" title="通道类型">
            <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="passwaytypeTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'

export default {
    data() {
        return {
     
        };
    },
    methods: {
        handleSubmit(searchP){
            this.$refs.passwaytypeTableID.handleSearch(searchP);
        },

        handleNew(){
            this.$router.push({
                path: "add_passwaytype",
                query: {id:''}
            });
        }
    },
    components:{
        tableE,
        searchE,
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
